// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11t7P","label":"styles_label__7EK_7"};